import React, { useState, useEffect } from "react";
import { Get_Schools_Fuzzy_Search } from "../../pages/Schools/api/Get_Schools_Fuzzy_Search";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import { Button, FormControl } from "@mui/material";
import { Get_One_From_MongoDB } from "../../api/Get_One_From_MongoDB";
import { StaffuseAuth } from "../../security/StaffuseAuth";
import { Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort } from "../../api/Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort";
import { Get_Invoices_Fuzzy_Search } from "../../pages/Xero/api/Get_Invoices_Fuzzy_Search";
import { Get_limited_Choose_Fields_With_Sort_From_MongoDB } from "../../api/Get_limited_Choose_Fields_With_Sort_From_MongoDB";

function SearchSetInvoices({ setInvoices }) {
  const { logout } = StaffuseAuth();

  const [InvoiceNumber, setInvoiceNumber] = useState("");
  const [StaffChosen, setStaffChosen] = useState("");
  const [limit, setlimit] = useState(10000);
  const [PaidStatus, setPaidStatus] = useState("UnPaid");
  const [DueAfter, setDueAfter] = useState("");
  const [DueBefore, setDueBefore] = useState("");
  const [Staff, setStaff] = useState([]);

  const handleSearchInvoiceNumber = (event) => {
    setInvoiceNumber(event.target.value);
  };
  const handleSearchStaffChosen = (event) => {
    setStaffChosen(event.target.value);
  };
  const handleLimitChange = (event) => {
    setlimit(event.target.value);
  };
  const handlePaidStatusChange = (event) => {
    setPaidStatus(event.target.value);
  };
  const handleDueAfterChange = (event) => {
    setDueAfter(event.target.value);
  };
  const handleDueBeforeChange = (event) => {
    setDueBefore(event.target.value);
  };

  function handleSubmitInvoiceSearch(e) {
    e.preventDefault();
    Get_Invoices_Fuzzy_Search(
      "Invoices",
      "Xero_2025",
      {
        InvoiceNumber: InvoiceNumber,
        Staff_id: StaffChosen,
        Paid_Status: PaidStatus,
        DueAfter: DueAfter,
        DueBefore: DueBefore,
      },
      Number(limit),
      setInvoices,
      { Due_Date: 1 },
      {},
      logout
    );
  }
  useEffect(() => {
    Get_limited_Choose_Fields_With_Sort_From_MongoDB(
      "Staff",
      "Users",
      100,
      { Username: 1 },
      setStaff,
      {
        Username: 1,
        Team: 1,
        Level: 1,
        _id: 1,
      },
      logout
    );
  }, []);

  let Arr_STX_Staff = Staff.filter((Obj_Staff) => {
    if (Obj_Staff.Team === "STX") {
      return Obj_Staff;
    }
  });

  return (
    <>
      <FormControl
        fullWidth
        sx={{ display: "flex", flexDirection: "row", gap: "10px" }}
      >
        <TextField
          key="handleSearchInvoiceNumber"
          name="handleSearchInvoiceNumber"
          label="Search Invoice Number"
          variant="outlined"
          value={InvoiceNumber}
          onChange={(e) => handleSearchInvoiceNumber(e)}
          sx={{ flex: "1 1 20%", marginBottom: "10px" }}
          InputProps={{
            style: {
              backgroundColor: "white",
            },
          }}
        />
        <TextField
          label="Limit"
          type="number"
          value={limit}
          onChange={handleLimitChange}
          sx={{ flex: "1 1 20%", marginBottom: "10px" }}
          variant="outlined"
          InputProps={{
            style: {
              backgroundColor: "white",
            },
          }}
        />
        <TextField
          label="Who Made Invoice"
          name="Staff_id"
          value={StaffChosen}
          onChange={handleSearchStaffChosen}
          sx={{ flex: "1 1 20%", marginBottom: "10px" }}
          InputProps={{
            style: {
              backgroundColor: "white",
            },
          }}
          InputLabelProps={{
            shrink: true,
          }}
          select
        >
          <MenuItem key={"---"} value={""}>
            ---
          </MenuItem>
          {Arr_STX_Staff.map((Obj_Staff) => (
            <MenuItem key={Obj_Staff._id} value={Obj_Staff._id}>
              {Obj_Staff.Username ? Obj_Staff.Username : ""}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          label="Paid_Status"
          name="Paid_Status"
          value={PaidStatus}
          type="number"
          onChange={handlePaidStatusChange}
          sx={{ flex: "1 1 20%", marginBottom: "10px" }}
          InputProps={{
            style: {
              backgroundColor: "white",
            },
          }}
          select
        >
          <MenuItem key={"---"} value={""}>
            ---
          </MenuItem>
          <MenuItem value="Paid">Paid</MenuItem>
          <MenuItem value="UnPaid">UnPaid</MenuItem>
          <MenuItem value="Credited">Credited</MenuItem>
        </TextField>
        <TextField
          label="Due After"
          name="DueAfter"
          value={DueAfter}
          type="date"
          onChange={handleDueAfterChange}
          sx={{ flex: "1 1 20%", marginBottom: "10px" }}
          InputProps={{
            style: {
              backgroundColor: "white",
            },
          }}
          InputLabelProps={{
            shrink: true,
          }}
        />
        <TextField
          label="Due Before"
          name="DueBefore"
          value={DueBefore}
          type="date"
          onChange={handleDueBeforeChange}
          sx={{ flex: "1 1 20%", marginBottom: "10px" }}
          InputProps={{
            style: {
              backgroundColor: "white",
            },
          }}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </FormControl>
      <Button
        variant="contained"
        color="primary"
        onClick={(e) => handleSubmitInvoiceSearch(e)}
        sx={{ alignSelf: "center" }}
      >
        Search Invoice
      </Button>
    </>
  );
}

export default SearchSetInvoices;
